import React from 'react';
import PageBanner from "@/components/pageBanner";

const SupportDiscord = () => {
    return (
        <>
            <PageBanner title="Discord Support Forum" slug="support-discord"/>
            <section className="generic-container py-14">

                <ul className={"list-disc pl-5"}>
                    <li>
                        <p className="font-bold">Installing Software for Troubleshooting AI Assistant Issues</p>
                        <p>
                            For users experiencing unique issues with the AI Assistant, we provide specialized
                            troubleshooting software. This guide will walk you through the installation process to help
                            diagnose and resolve potential problems.
                        </p>
                    </li>
                    <li className="mt-4">
                        <p className="font-bold">How to Register on Discord</p>
                        <p>
                            To access personalized technical support, follow these steps to create a Discord account:
                        </p>
                    </li>
                    <ol className={"mt-2"}>
                        <li>1. Go to <a href="https://discord.com/" target="_blank" className="text-lt-blue">Discord’s
                            official website</a>.
                        </li>
                        <li>2. Click on Sign Up and enter your email, username, password, and date of birth.</li>
                        <li>3. Verify your email by clicking the link sent to your inbox.</li>
                        <li>4. Download and install the Discord app for a better experience or use the web version.</li>
                        <li>5. Log in and complete your profile setup.</li>
                    </ol>
                    <li className="mt-4">
                        <p className="font-bold">Join Our Support Group</p>
                        <p>
                            Once you’ve set up your Discord account, join our support server by clicking the link below:  <a href="https://discord.gg/CRPghuUz" target="_blank" className="text-lt-blue">https://discord.gg/CRPghuUz</a>
                        </p>
                        <p>
                            After joining, navigate to the Support channel where our team and community members can assist you with troubleshooting the AI Assistant.
                        </p>
                    </li>
                </ul>

            </section>
        </>
    )
}

export default SupportDiscord;